import * as React from 'react'

import { RouteConfig } from 'react-router-config'

const routeConfig: RouteConfig[] = [
  {
    path: '/all-graphics/pg-:page(\\d+)'
  },
  {
    path: '/all-graphics'
  },
  {
    path: '/graphics-with-:term-in-:category([\\w/-]+)/pg-:page(\\d+)'
  },
  {
    path: '/graphics-with-:term-in-:category([\\w/-]+)'
  },
  {
    path: '/:term-and-:tags-graphics-in-:category([\\w/-]+)/pg-:page(\\d+)'
  },
  {
    path: '/:term-and-:tags-graphics-in-:category([\\w/-]+)'
  },
  {
    path: '/:term-and-:tags-graphics/pg-:page(\\d+)'
  },
  {
    path: '/:term-and-:tags-graphics'
  },
  {
    path: '/:tags-graphics-in-:category([\\w/-]+)/pg-:page(\\d+)'
  },
  {
    path: '/:tags-graphics-in-:category([\\w/-]+)'
  },
  {
    path: '/:term-in-graphics/pg-:page(\\d+)'
  },
  {
    path: '/:term-in-graphics'
  },
  {
    path: '/:tags-graphics/pg-:page(\\d+)'
  },
  {
    path: '/:tags-graphics'
  },
  {
    path: '/:category+/pg-:page(\\d+)'
  },
  {
    path: '/:category+'
  }
]

export default routeConfig
